import {validateAndRetrieveLinks} from '../../helpers/apiHelper';
import { serializeMenu } from '../menu/menu.service';
import { LinkModel } from './link.types';

export const validateLinkService = async (linkAlias: string) => {
  try{
    const response = await validateAndRetrieveLinks(linkAlias);
    return response;
  }catch(e){
    alert(e);
  }
};

export const serializeLink = (
  data: {[key:string]: any}
): LinkModel => {
  return {
    id: data.id,
    menus: (data.menus ?? []).map(serializeMenu),
    service_mode: data.service_mode,
    service_type_path: data.service_type_path,
    name: data.name,
  };
};